import { Box, Typography } from "@mui/material";
import type { ReactNode } from "react";

type Props = {
  title: string;
  description?: ReactNode;
};

export const TimelineStepContent = ({ title, description }: Props) => {
  return (
    <Box flex={1} pt={0.5} gap={1}>
      <Typography variant="body1" fontWeight={600} fontSize="1rem">
        {title}
      </Typography>
      {description && (
        <Typography
          component="div"
          variant="body2"
          color="text.secondary"
          fontSize="0.875rem"
          lineHeight={1.5}
        >
          {description}
        </Typography>
      )}
    </Box>
  );
};
